import { h, Component } from "preact";
import { Container } from "../container";
import { StoryDTO } from "../../model/Item";
import { getTopStoryIds } from "../../api/getTopStoryIds";
import { getItem } from "../../api/getItem";
import { getItems } from "../../api/getItems";
import { NavBar } from "../navbar";
import { saveStateAndPage } from "../../savePageAndState";

const PAGE_SIZE = 25;

interface HomeProps {
    savedState: HomeState | undefined;
}

interface HomeState {
    displayedStories: number;
    stories: StoryDTO[];
    storyIds: number[];
}

export class Home extends Component<HomeProps, HomeState> {
    constructor(props: HomeProps) {
        super(props);

        if (this.props.savedState) {
            this.state = this.props.savedState;
        } else {
            this.state = {
                displayedStories: 0,
                stories: [],
                storyIds: []
            };
        }
    }

    async componentDidMount() {
        document.title = 'HN-infinite';
        if (!this.props.savedState) {
            const storyIds = await getTopStoryIds();

            this.setState({
                displayedStories: PAGE_SIZE,
                stories: await getItems(storyIds.slice(0, PAGE_SIZE)) as StoryDTO[],
                storyIds: storyIds
            });
        }
    
        window.onscroll = async () => {
            const container = document.getElementById("container");
            if (!container) {
                return;
            }
            const avgHeight = (container.offsetHeight - 24) / this.state.displayedStories;
            if (window.scrollY + PAGE_SIZE * avgHeight > this.state.displayedStories * avgHeight) {
                this.setState({
                    displayedStories: this.state.displayedStories + 1
                });
                // TODO: This is incorrect but probably works...
                const stories = this.state.stories;
                stories.push(
                    await getItem(this.state.storyIds[this.state.displayedStories - 1]) as StoryDTO
                );
                this.setState({
                    stories
                });
            }
        }
        
        saveStateAndPage(location.pathname, this.state);
    }

    componentDidUpdate() {
        saveStateAndPage(location.pathname, this.state);
    }

    componentWillUnmount() {
        window.onscroll = null;
    }

    render() {
        return <div>
            <NavBar buttonsToShow={["FORCE_REFRESH"]} />
            <Container stories={this.state.stories} />
        </div>
    }
}
